export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7431.8dfb0419.jpg";